import "$styles/index.css";

// Импорт всех JS/CSS файлов из src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}";

// Мобильное меню
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("menuBtn");
  const nav = document.getElementById("mobileNav");
  if (btn && nav) {
    const setOpen = (open) => {
      nav.classList.toggle("hidden", !open);
      btn.setAttribute("aria-expanded", String(open));
    };

    btn.addEventListener("click", () => setOpen(nav.classList.contains("hidden")));

    // Выбор пункта закрывает панель, иначе она остаётся висеть поверх секции
    nav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => setOpen(false));
    });

    document.addEventListener("click", (e) => {
      if (!nav.classList.contains("hidden") && !nav.contains(e.target) && !btn.contains(e.target)) {
        setOpen(false);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setOpen(false);
    });
  }

  // Переключатель темы
  const toggle = document.getElementById("themeToggle");
  if (toggle) {
    toggle.addEventListener("click", () => {
      const root = document.documentElement;
      const isDark = root.classList.toggle("dark");
      try {
        localStorage.setItem("theme", isDark ? "dark" : "light");
      } catch (e) {}
    });
  }

  // Выпадающий переключатель языка
  const langBtn = document.getElementById("langBtn");
  const langMenu = document.getElementById("langMenu");
  if (langBtn && langMenu) {
    const setOpen = (open) => {
      langMenu.classList.toggle("hidden", !open);
      langBtn.setAttribute("aria-expanded", String(open));
    };

    langBtn.addEventListener("click", () => setOpen(langMenu.classList.contains("hidden")));

    document.addEventListener("click", (e) => {
      if (!langMenu.classList.contains("hidden") && !langMenu.contains(e.target) && !langBtn.contains(e.target)) {
        setOpen(false);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setOpen(false);
    });
  }
});
